import { ReactNode } from 'react'

type ToastVariant = 'info' | 'success' | 'error'

interface ToastAction {
  label: string
  onClick?: (toast: ToastInstance) => void
}

interface BaseToastInstance {
  id: string
  createdAt: number
}

export interface DefaultToastInstance extends BaseToastInstance {
  title: string
  variant: ToastVariant
  description?: ReactNode
  action?: ToastAction
  dismissable: boolean
  ttl: number
}

export interface CustomToastInstance extends BaseToastInstance {
  customJsx: ReactNode
}

export type ToastInstance = CustomToastInstance | DefaultToastInstance

export interface CustomToastData {
  customJsx: ReactNode
}

export interface DefaultToastData {
  id?: string
  title: string
  description?: ReactNode
  action?: ToastAction
  variant?: ToastVariant
  dismissable?: boolean
  ttl?: number
}

export type ToastData = CustomToastData | DefaultToastData
